import { useEffect, useState } from "react";
import { quickOptionsDefaultValues } from "../features/cargo/constants";
import { useGetCurrentUserQuery } from "../features/user/userApiSlice";

export const useCargoQuickOptions = () => {
	const { data: user, isFetching } = useGetCurrentUserQuery(undefined);

	const [weightOptions, setWeightOptions] = useState([]);
	const [lengthOptions, setLengthOptions] = useState([]);
	const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);
	const [vehicleBodyOptions, setVehicleBodyOptions] = useState([]);
	const [additionalRequirementsOptions, setAdditionalRequirementsOptions] =
		useState([]);

	useEffect(() => {
		user?.preferences?.quickOptions["weight"].length > 0
			? setWeightOptions(user.preferences.quickOptions.weight)
			: setWeightOptions(quickOptionsDefaultValues.weight);

		user?.preferences?.quickOptions["length"].length > 0
			? setLengthOptions(user.preferences.quickOptions["length"])
			: setLengthOptions(quickOptionsDefaultValues["length"]);

		user?.preferences?.quickOptions["vehicleTypeId"].length > 0
			? setVehicleTypeOptions(user.preferences.quickOptions["vehicleTypeId"])
			: setVehicleTypeOptions(quickOptionsDefaultValues["vehicleTypeId"]);

		user?.preferences?.quickOptions["vehicleBodyId"].length > 0
			? setVehicleBodyOptions(user.preferences.quickOptions["vehicleBodyId"])
			: setVehicleBodyOptions(quickOptionsDefaultValues["vehicleBodyId"]);

		user?.preferences?.quickOptions["additionalRequirements"].length > 0
			? setAdditionalRequirementsOptions(
					user.preferences.quickOptions["additionalRequirements"]
			  )
			: setAdditionalRequirementsOptions(
					quickOptionsDefaultValues["additionalRequirements"]
			  );
	}, [user]);

	return {
		weightOptions,
		lengthOptions,
		vehicleTypeOptions,
		vehicleBodyOptions,
		additionalRequirementsOptions,
		isUpdating: isFetching,
	};
};
